import React from 'react';
import { mediaDir } from '../../../../../appolloConfig';
import { sanitizeCalculToString } from '../../../../../helpers/number/sanitizeCalul';
import { ProductTypes } from '../../../../../types/product/product';
import useIsMobile from 'helpers/responsive/useIsMobile';
import { CarouselTag } from 'components/molecules/Carousel/CarouselTag';
import { CarouselTags } from 'components/molecules/Carousel/CarouselTags';
import useStyle from './productListPresentation.style';

export interface ProductListPresentationProps {
  product: ProductTypes;
  onClick: () => void;
  isPublicShop?: boolean;
}

const ProductListPresentation = ({
  product,
  onClick,
  isPublicShop = false
}: ProductListPresentationProps) => {
  const classes = useStyle();
  const isMobile = useIsMobile();
  const catProduct = product?.categorieproduits;
  return (
    <div className={classes.root}>
      {!isMobile && (
        <div className={classes.media} onClick={onClick}>
          {product.media && product.media.length > 0 && (
            <div className={classes.imageContainer}>
              <img
                src={mediaDir + product?.media[0]?.url}
                alt={product?.name}
                className={classes.image}
              />
            </div>
          )}
        </div>
      )}
      <div className={classes.description}>
        <h2 onClick={onClick}>
          {product.ref} - {product.name}
        </h2>
        <div className={classes.labels}>
          <div className={classes.carousel}>
            {catProduct.length > 1 && <CarouselTags tags={catProduct} />}
            {catProduct.length === 1 && <CarouselTag tag={catProduct[0]} />}
          </div>
          <div className={classes.price}>
            <p>
              {sanitizeCalculToString(product.ttcPrice)}€ TTC - Poids net{' '}
              {product.netWeight} g
            </p>
          </div>
          {isPublicShop && <p>{product.catchPhrase && product.catchPhrase}</p>}
        </div>
      </div>
    </div>
  );
};

export default ProductListPresentation;
